'use strict';

angular.module('app.constants', [])
    .constant('commonConsts', {
        KeywordTypes: {
            KEYWORD: 1,
            URL: 2,
            HASH_TAG: 3
        },
        KeywordStatuses: {
            NEW: 1,
            VERIFIED: 2
        },
        AccessLevels: {
            USER: 'User',
            ADMINISTRATOR: 'Administrator',
            INFLUENCER: 'influencer'
        }
    })
    .constant('campaignConsts', {
        Types: {
            CAMPAIGN_CREATION: 'CAMPAIGN_CREATION',
            CAMPAIGN_CURATION: 'CAMPAIGN_CURATION'
        },
        Statuses: {
            INVITED: 'INVITED',
            ACCEPTED: 'ACCEPTED',
            REJECTED: 'REJECTED',
            DECLINED: "DECLINED",
            PUBLISHED: 'PUBLISHED',
            INTERESTED: 'INTERESTED'
        }
    })
    .constant('TRACK_EVENTS', {
        CLICK_ON_PROJECT: {
            EVT_NAME: 'View',
            ITEM_NAME: 'Project'
        },
        CLICK_ON_MENTION: {
            EVT_NAME: 'View',
            ITEM_NAME: 'Project'
        },
        CLICK_ON_INFLUENCER_GROUP: {
            EVT_NAME: 'View',
            ITEM_NAME: 'Influencer Group'
        },
        CLICK_ON_INFLUENCER: {
            EVT_NAME: 'View',
            ITEM_NAME: 'Influencer'
        },
        CLICK_ON_CAMPAIGN: {
            EVT_NAME: 'View',
            ITEM_NAME: 'Campaign'
        },
        USE_REPORT: {
            EVT_NAME: 'View',
            ITEM_NAME: 'Measure'
        },
        USE_DEMOGRAPHIC: {
            EVT_NAME: 'View',
            ITEM_NAME: 'Demographics'
        },
        USE_DISCOVER: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Discover'
        },
        CREATE_INFLUENCER_GROUP: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Influencer Group'
        },
        CREATE_CAMPAIGN: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Campaign'
        },
        CREATE_REPORT: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Report'
        },
        CREATE_PROJECT: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Project'
        },
        CREATE_MENTION: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Mention'
        },
        LOGIN: {
            EVT_NAME: 'Login',
            ITEM_NAME: 'Login'
        },
        CREATE_NOTIFICATION: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Notification'
        },
        UPDATE_NOTIFICATION: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Notification'
        },
        UPGRADE_SUBSCRIPTION: {
            EVT_NAME: 'Action',
            ITEM_NAME: 'Subscription'
        },
        VISIT_PAGE: {
            EVT_NAME: 'View',
            ITEM_NAME: 'View',
            PAGES: [
                {
                    NAME: 'Home Tab',
                    STATE: 'home.dashboard'
                },
                {
                    NAME: 'Discover Tab',
                    STATE: 'home.discover'
                },
                {
                    NAME: 'Influencer Tab',
                    STATE: 'home.influencer'
                },
                {
                    NAME: 'Campaign Tab',
                    STATE: 'home.campaignAdvertiserManagePage'
                },
                {
                    NAME: 'Campaign Tab',
                    STATE: 'home.campaignInfluencersManagePage'
                },
                {
                    NAME: 'Measure Tab',
                    STATE: 'home.measure'
                },
                {
                    NAME: 'Settings Page',
                    STATE: 'home.profile'
                },
                {
                    NAME: 'Change Password Modal',
                    STATE: 'home.profileChangePassword'
                },
                {
                    NAME: 'Notification Center Page',
                    STATE: 'home.profileNotificationCenter'
                },
                {
                    NAME: 'Billing Page',
                    STATE: 'home.profileBilling'
                }
            ]
        },
        PAGE_STATE_MAPPING: {
            'home.dashboard' : 'Home',
            'home.influencer': 'Influencer Group',
            'home.campaignAdvertiserManagePage': 'Campaign',
            'home.campaignInfluencersManagePage': 'Campaign'
        }
    });